import http from './httpService';
const apiUrl = process.env.REACT_APP_API_URL;
const apiEndpoint = apiUrl + '/rvss';

function rvsUrl(id) {
	return `${apiEndpoint}/${id}`;
}

export function getrvss() {
	return http.get(apiEndpoint);
}

export function getrvs(Id) {
	return http.get(rvsUrl(Id));
}

export function savervs(rvs, selectedFile = null) {
	const body = { ...rvs };
	
	delete body.userNo;
	
	Object.keys(body).forEach(key => {
		if (typeof body[key] === 'string') {
			body[key] = body[key].trim();
			if (body[key] === '' && key !== 'RVS') {
				body[key] = null;
			}
		}
	});
	
	if (body._id) {
		const id = rvsUrl(body._id);
		delete body._id;
		return http.put(id, body);
	}
	
	if (!body.RVS) {
		return Promise.reject({
			response: {
				status: 400,
				data: { message: 'RVS Name is a required field.' }
			}
		});
	}
	
	return http.post(apiEndpoint, body);
}

export function deletervs(Id) {
	return http.delete(rvsUrl(Id));
}